import React, { useState }  from 'react';

function SearchField({ onBlurValue }) {
  const [value, setValue] = useState("");
  
  const handleBlur = () => {
    onBlurValue(value);
  };

  const clearInput = () => {
    setValue('');
    onBlurValue('')
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onBlurValue(value);
      e.preventDefault();
    }
  }
  
    return (

      // <div style={{ display: "flex", justifyContent: "flex-end", padding: 20 }}>
        <div style={{ position: "relative", width: 250 }}>
          {/* Magnifying glass icon */}
          <div
            onClick={handleBlur}
            style={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#888",
              cursor: "pointer", // show pointer on hover
              userSelect: "none"
            }}
            title="Search"
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
          >
            {/* Inline SVG for magnifying glass */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="16"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16a6.471 6.471 0 004.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM9.5 14A4.5 4.5 0 119.5 5a4.5 4.5 0 010 9z" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            style={{
              borderRadius: '10px',
              fontSize: '14px',
              fontFamily: 'sans-serif',
              height: '32px',
              width: '100%',
              paddingLeft: 32,
              paddingRight: 30
            }}
          />
                            
          {/* Clear button */}
          {value && (
            <button
              onClick={clearInput}
              style={{
                position: "absolute",
                right: 6,
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
                color: "#888",
                padding: 0,
              }}
              aria-label="Clear search"
            >
              &times;
            </button>
          )}
        </div>
      // </div>
    );
  };

export default SearchField;
